/* global axios */
import ApiClient from './ApiClient';

class TalkviaFactaOfflineBatchesAPI extends ApiClient {
  constructor() {
    super('talkvia_facta_offline_batches', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  integration() {
    return axios.get(`${this.url}/integration`);
  }

  create(data) {
    return axios.post(this.url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  download(id) {
    return axios.get(`${this.url}/${id}/download`, { responseType: 'blob' });
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  downloadUrl(id) {
    return `${this.url}/${id}/download`;
  }
}

export default new TalkviaFactaOfflineBatchesAPI();
